export function setShowcaseSlug(payload) {
  return { type: "SET_SHOWCASE_SLUG", payload };
}
